// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-complete-item[data-v-032d7d67]{transition:all .4s ease}.list-complete-enter[data-v-032d7d67],.list-complete-leave-to[data-v-032d7d67]{opacity:0;transform:translateX(50vw)}.list-complete-leave-active[data-v-032d7d67]{position:absolute}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
